export function trackEvent(
  eventName: string,
  eventData?: Record<string, string>,
) {
  if (typeof umami !== "undefined") {
    umami.track(eventName, eventData);
  }
}
